import React, { useState, useEffect } from "react";
import "./CheckboxPadrao.css";
import { FaCheck } from "react-icons/fa6";

/**
 * CheckboxPadrao - Componente de checkbox que gerencia listas de objetos com id e descrição
 * usando apenas Map para melhor performance
 * 
 * @param {string} label - Label do checkbox
 * @param {boolean} checked - Estado inicial do checkbox
 * @param {string|number} valueId - ID do item associado ao checkbox (será convertido para inteiro)
 * @param {string} valueDescription - Descrição do item associado ao checkbox (opcional). Se não fornecido, o map armazenará apenas o objeto com ID.
 * @param {function} updateStateCallback - Callback que recebe o Map atualizado
 * @param {Map} itemsMap - Mapa de itens selecionados
 * @param {string} className - Classe CSS adicional para o label
 */
const CheckboxPadrao = ({ 
  label,
  checked: checkedProp = false,
  valueId,
  valueDescription,
  updateStateCallback,
  itemsMap,
  className = "",
  onChange, // Adicionado callback simples para eventos de onChange
  labelStyle = "default" // Nova prop para controlar o estilo do label (default | capitalize)
}) => {
  // NÃO converta valueId para inteiro!
  // const intValueId = valueId !== undefined && valueId !== null ? parseInt(valueId, 10) : null;
  const realValueId = valueId;
  
  const [checked, setChecked] = useState(!!checkedProp);
  
  useEffect(() => {
    if (itemsMap) {
      setChecked(!!itemsMap.has(realValueId));
    } else {
      setChecked(!!checkedProp);
    }
  }, [checkedProp, realValueId, itemsMap]);
  
  const handleClick = (e) => {
    e?.preventDefault?.();
    const newChecked = !checked;
    setChecked(newChecked);
    
    if (onChange) {
      onChange({
        target: {
          checked: newChecked
        }
      });
    }
    
    if ((realValueId === undefined || realValueId === null) || !updateStateCallback) return;

    const newMap = new Map(itemsMap || new Map());
    
    if (newChecked) {
      if (valueDescription) {
        newMap.set(realValueId, {
          id: realValueId,
          descricao: valueDescription !== undefined ? valueDescription : label
        });
      } else {
        newMap.set(realValueId, { id: realValueId });
      }
    } else {
      newMap.delete(realValueId);
    }
    
    updateStateCallback(newMap);
  };

  return (
    <label className={`checkbox-padrao-container ${className}`} onClick={handleClick}>
      <span
        className={`checkbox-padrao-box${checked ? " checked" : ""}`}
        role="checkbox"
        aria-checked={checked}
        tabIndex={0}
        onKeyDown={e => (e.key === " " || e.key === "Enter") && handleClick(e)}
      >
        {checked && <FaCheck className="checkbox-padrao-icon" />}
      </span>
      {label && (
        <span className={`checkbox-padrao-label ${labelStyle === 'capitalize' ? 'checkbox-padrao-label-capitalize' : ''}`}>
          {labelStyle === 'capitalize' ? label : label?.toUpperCase()}
        </span>
      )}
    </label>
  );
};

export default CheckboxPadrao;
